<template>
  <el-dialog
    title="合伙人信息"
    :visible.sync="dialogVisible"
    customClass="customWidth"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      size="mini"
    >
      <el-row>
        <el-col :span="8">
      <el-form-item
        prop="legal"
        label="姓名"
      >
        <el-input v-model="form.legal" :disabled="true"></el-input>
      </el-form-item>
        </el-col>
        <el-col :span="8">
      <el-form-item
        prop="userName"
        label="公司/个人"
      >
        <el-input v-model="form.userName" :disabled="true"></el-input>
      </el-form-item>
        </el-col>
        <el-col :span="8">
      <el-form-item
        prop="mobileNo"
        label="手机"
      >
        <el-input v-model="form.mobileNo" :disabled="true"></el-input>
      </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
      <el-form-item
              prop="prov_cd"
              label="省"
      >
        <el-select
                class="filter-item"
                v-model="form.prov_cd"
                placeholder="请选择省"
                :disabled="true"
                @change="currentSel(form.prov_cd)"
        >
          <el-option
                  v-for="item in typeOptions"
                  :key="item.areaid"
                  :label="item.areaname"
                  :value="item.areaid"
          ></el-option>
        </el-select>
      </el-form-item>
        </el-col>
        <el-col :span="8">
      <el-form-item
              prop="city"
              label="市"
      >
        <el-select
                class="filter-item"
                v-model="form.city"
                placeholder="请选择市"
                :disabled="true"
        >
          <el-option
                  v-for="item in typeOptions2"
                  :key="item.areaid"
                  :label="item.areaname"
                  :value="item.areaid"
          ></el-option>
        </el-select>
      </el-form-item>
        </el-col>

      </el-row>
      <el-row>
        <el-col :span="8">
      <el-form-item
              prop="compaddress"
              label="地址"
      >
        <el-input v-model="form.compaddress" :disabled="true"></el-input>
      </el-form-item>
        </el-col>
        <el-col :span="8">
      <el-form-item
              prop="contractstdate"
              label="合同开始日期"
      >

        <el-date-picker
                v-model="form.contractstdate"
                type="date"
                :picker-options="pickerOptions" value-format="yyyy-MM-dd" :disabled="true">
        </el-date-picker>

      </el-form-item>
        </el-col>
        <el-col :span="8">
      <el-form-item
              prop="contractendate"
              label="合同结束日期"
      >
        <el-date-picker
                v-model="form.contractendate"
                type="date"
                :picker-options="pickerOptions" value-format="yyyy-MM-dd" :disabled="true">
        </el-date-picker>
      </el-form-item>
        </el-col>
      </el-row>

    </el-form>

    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="区县合伙人" name="second">
        <child2 v-if="isChildUpdate2" :agentid_f2="agentid_f2" :xt_id_f2="xt_id_f2" :dl_type_f2="dl_type_f2"></child2>

      </el-tab-pane>

    </el-tabs>

  </el-dialog>

</template>
<style>
  .customWidth{
    width:80%;
  }
</style>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as userService from "@/api/sys/user";
    import util from '@/libs/util.js'
    import tabZujianChild2 from './tabZujianChild2'
export default {
  name: "oneagentEditForm",
    components:{
        child2:tabZujianChild2
    },
  props: {
      oneagent: Object,
    value: Boolean
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
        activeName :'second',
        pickerOptions: {}, // 日期设置对象
        isChildUpdate2:true,
        xt_id_f2:"",
        agentid_f2:"",
        dl_type_f2:"",


      form: {
      legal: "",
          userName: "",
          mobileNo: "",
          compaddress: "",
          contractstdate: "",
          contractendate: ""
      },
        typeOptions: [],
        typeOptions2: []
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
        this.xt_id_f2=this.oneagent.xt_id;
        this.agentid_f2=this.oneagent.agentid;
        this.dl_type_f2=this.oneagent.dl_type;


    }
  },
  methods: {
    dialogOpen() {
      this.$refs.form.resetFields();
        var formData2 = new FormData() // 声明一个FormData对象
        agentService.getProvcd(formData2).then(data => {
            this.typeOptions=data;
        });
        if(this.oneagent.city){
            this.currentSel(this.oneagent.prov_cd);
        }

      if (this.oneagent.userId) {
       // userService.getUser(this.user.id).then(data => {
          let form = {};
          form.legal = this.oneagent.legal;
          form.userName = this.oneagent.userName;
          form.mobileNo = this.oneagent.mobileNo;
          form.prov_cd = this.oneagent.prov_cd;
          form.city = this.oneagent.city;
          form.compaddress = this.oneagent.compaddress;
          form.contractstdate = this.oneagent.contractstdate;
          form.contractendate = this.oneagent.contractendate;
          this.form = form;
       // });
      } else {
        this.form = {};
      }
    },
      handleClick(tab, event) {
          console.log(tab, event);
          if(tab.name == 'second'){
              // 触发‘用户管理’事件
              this.isChildUpdate2 = true;
          }
      },
      currentSel(val) {
          if (this.oneagent.userId) {
              this.form.city = "";
              this.form.areaid = "";
          }
          this.typeOptions2=[];
          var formData2 = new FormData() // 声明一个FormData对象

          formData2.append('type','city')
          formData2.append('areaid',val)
          agentService.getProvcd(formData2).then(data => {
              this.typeOptions2=data;
          });
      },

    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

